export const L2_ASSIGNEES = [
  "Soumyajeet",
  "Debalina",
];

export const STEPS = {
  PRIMARY: "primary",
  CONTACTED: "contacted",
  QUIET: "quiet",

  FOLLOW_UP: "follow_up",
  FOLLOW_UP_COMPLETE: "follow_up_complete",

  CUSTOMER_CALLBACK: "customer_callback",

  TRANSFER_L2: "transfer_l2",
  L2: "l2",

  CLOSE: "close",
  BOOKED: "booked",
};

export const TABS = {
  ACTION: "action",
  HISTORY: "history",
};

export const IST_TIMEZONE =
  "Asia/Kolkata";